import { Step } from "@/lib/types";

export const warmupDaysStep: Step = {
  id: "warmup-days",
  type: "dayStep",
  title: "Account Warm-up",
  description: "🚨 This warm-up step is SUPER IMPORTANT. If you don't do it like this your posts will have low views and we won't be able to continue working with you 😢.",
  buttonText: "Start Warm-up",
  days: [
    // Day 1
    {
      day: 1,
      title: "Warm-up day one",
      subSteps: [
        {
          id: "day1-step1",
          title: "Step 1",
          description: "Follow these accounts and engage with their content:",
          todos: [
            {
              id: "follow-flamingo",
              text: "Follow @flamingo.cards",
              link: "https://www.tiktok.com/@flamingo.cards",
              completed: false
            },
            {
              id: "follow-hhtalk",
              text: "Follow @hhtalk",
              link: "https://www.tiktok.com/@hhtalk",
              completed: false
            },
            {
              id: "follow-sunnahlove",
              text: "Follow @sunnahlove.net",
              link: "https://www.tiktok.com/@sunnahlove.net",
              completed: false
            },
            {
              id: "follow-couple-cards",
              text: "Follow @couple_cards",
              link: "https://www.tiktok.com/@couple_cards",
              completed: false
            },
            {
              id: "follow-melodiacards",
              text: "Follow @melodiacards",
              link: "https://www.tiktok.com/@melodiacards/",
              completed: false
            },
            {
              id: "followed-all",
              text: "I followed all these accounts",
              completed: false
            }
          ],
          buttonText: "Continue",
          buttonTimer: 180 // 3 minutes
        },
        {
          id: "day1-step2",
          title: "Step 2",
          description: "Search for these keywords and watch 4 videos for each:",
          todos: [
            {
              id: "search-deep-questions",
              text: "Search \"deep questions\" and watch 4 videos",
              completed: false,
              hint: "Make sure to type exactly: deep questions"
            },
            {
              id: "search-couple-advice",
              text: "Search \"couple advice\" and watch 4 videos",
              completed: false,
              hint: "Make sure to type exactly: couple advice"
            },
            {
              id: "search-couple-game",
              text: "Search \"couple game\" and watch 4 videos",
              completed: false,
              hint: "Make sure to type exactly: couple game"
            }
          ],
          buttonText: "Continue",
          buttonTimer: 300 // 5 minutes
        },
        {
          id: "day1-step3",
          title: "Step 3",
          description: "",
          todos: [
            {
              id: "scroll-fyp-day1",
              text: "Scroll in your for-you page DURING 15 MINUTES. Try to have couple related content in your for-you page (important)",
              completed: false
            }
          ],
          buttonText: "Finish Day 1",
          buttonTimer: 900 // 15 minutes (15 * 60 = 900 seconds)
        }
      ]
    },
    
    // Day 2
    {
      day: 2,
      title: "Warm-up day two",
      subSteps: [
        {
          id: "day2-step1",
          title: "Step 1",
          description: "",
          todos: [
            {
              id: "hashtag-couplequestions",
              text: "Search for #couplequestions and watch 4 videos",
              completed: false,
              hint: "Make sure to type exactly: #couplequestions"
            },
            {
              id: "hashtag-deepquestions",
              text: "Search for #deepquestions and watch 4 videos",
              completed: false,
              hint: "Make sure to type exactly: #deepquestions"
            },
            {
              id: "hashtag-coupleadvice",
              text: "Search for #coupleadvice and watch 4 videos",
              completed: false,
              hint: "Make sure to type exactly: #coupleadvice"
            }
          ],
          buttonText: "Continue",
          buttonTimer: 300 // 5 minutes
        },
        {
          id: "day2-step2",
          title: "Step 2",
          description: "",
          todos: [
            {
              id: "scroll-fyp-day2",
              text: "Scroll in your for-you page DURING 15 MINUTES. Try to have couple related content in your for-you page (important)",
              completed: false
            }
          ],
          buttonText: "Finish Day 2",
          buttonTimer: 900 // 15 minutes (15 * 60 = 900 seconds)
        }
      ]
    },
    
    // Day 3
    {
      day: 3,
      title: "Warm-up day three: Last day of warm-up!",
      subSteps: [
        {
          id: "day3-step1",
          title: "Step 1",
          description: "",
          todos: [
            {
              id: "scroll-fyp-day3",
              text: "Scroll in your for-you page DURING 15 MINUTES. Try to have couple related content in your for-you page (important)",
              completed: false
            }
          ],
          buttonText: "Continue",
          buttonTimer: 900 // 15 minutes
        },
        {
          id: "day3-step2",
          title: "Step 2",
          description: "Open Tiktok, create a post by taking a picture of your desk / room directly in Tiktok and add the text \"I'll share deep questions you can ask your soulmate, be ready!\" and post it.",
          todos: [
            {
              id: "create-first-post",
              text: "I created my first post!",
              completed: false
            }
          ],
          buttonText: "Continue Onboarding",
        }
      ]
    }
  ]
};
